import { injectable } from 'inversify';
import { computed } from 'mobx';
import { CardModel } from '../../interfaces/models/CardModel';
import { CardStore } from '../CardStore';

@injectable()
export abstract class BaseCardStore<T extends CardModel> {

    protected constructor(
        protected cardStore: CardStore
    ) {}

    /**
     * Get the current card for the local card store that extends BaseCardStore
     */
    @computed get card(): T {
        return this.cardStore.currentCard as T;
    }

}
